import { Directive, ElementRef, AfterViewInit, OnDestroy, NgZone } from '@angular/core';

@Directive({
    selector: '[appDraggableTabs]',
    standalone: true
})
export class DraggableTabsDirective implements AfterViewInit, OnDestroy {
    private _isDown = false;
    private _startX = 0;
    private _scrollLeft = 0;
    private _headerElement: HTMLElement | null = null;

    constructor(private el: ElementRef, private ngZone: NgZone) { }

    ngAfterViewInit() {
        // Wait for Material to render
        setTimeout(() => {
            // With the CSS overrides, .mat-mdc-tab-label-container is now the scrollable element
            this._headerElement = this.el.nativeElement.querySelector('.mat-mdc-tab-label-container') ||
                this.el.nativeElement.querySelector('.mat-tab-label-container');

            if (this._headerElement) {
                console.log('DraggableTabs: Found draggable container', this._headerElement);
                this.initDragHandlers();

                this._headerElement.style.cursor = 'grab';
                this._headerElement.style.userSelect = 'none';
            } else {
                console.warn('DraggableTabs: Could not find tab label container.');
            }
        }, 500); // 500ms to be safe
    }

    private initDragHandlers() {
        if (!this._headerElement) return;

        this.ngZone.runOutsideAngular(() => {
            const el = this._headerElement!;

            // MOUSE EVENTS
            el.addEventListener('mousedown', (e: MouseEvent) => {
                if (e.which !== 1) return; // Only primary button
                this._isDown = true;
                el.style.cursor = 'grabbing';
                this._startX = e.pageX - el.offsetLeft;
                this._scrollLeft = el.scrollLeft;
                console.log('DraggableTabs: Drag started');
            });

            el.addEventListener('mouseleave', () => {
                this._isDown = false;
                el.style.cursor = 'grab';
            });

            el.addEventListener('mouseup', () => {
                this._isDown = false;
                el.style.cursor = 'grab';
            });

            el.addEventListener('mousemove', (e: MouseEvent) => {
                if (!this._isDown) return;
                e.preventDefault(); // Prevent text selection etc
                const x = e.pageX - el.offsetLeft;
                const walk = (x - this._startX) * 1.0; // 1:1 movement feels most natural
                el.scrollLeft = this._scrollLeft - walk;
                // console.log('DraggableTabs: Scrolling', el.scrollLeft);
            });

            // TOUCH EVENTS (Just in case, though mobile usually works)
            el.addEventListener('touchstart', (e: TouchEvent) => {
                this._isDown = true;
                this._startX = e.touches[0].pageX - el.offsetLeft;
                this._scrollLeft = el.scrollLeft;
            });

            el.addEventListener('touchmove', (e: TouchEvent) => {
                if (!this._isDown) return;
                const x = e.touches[0].pageX - el.offsetLeft;
                const walk = (x - this._startX) * 1.0;
                el.scrollLeft = this._scrollLeft - walk;
            });

            el.addEventListener('touchend', () => {
                this._isDown = false;
            });
        });
    }

    ngOnDestroy() {
        // Listeners added via DOM API in runOutsideAngular should technically be cleaned up 
        // but complexity of named functions vs anonymous binding makes it verbose. 
        // Given the directive lifecycle matches component, leakage is minimal for valid app lifetime.
        // For strictness, could save references.
    }
}
